import React, { useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { scaleQuantize } from "d3-scale";

const Maps = ({ stateData }: any) => {
  const [tooltipContent, setTooltipContent] = useState<any>({
    name: "",
    count: "",
  });

  // Generate a small unique variation for each state
  const getUniqueVariation = (name: any) => {
    const hash = [...name].reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return (hash % 10) * 0.01; // This creates a small variation
  };

  const colorScale = scaleQuantize<string>()
    .domain([0, Math.max(...stateData.map(({ count }: any) => count))])
    .range([
      "#b580ff",
      "#8b47ea",
      "#8b6697",
      "#b199ba",
      "#2e003e",
      "#3d0052",
      "#745082",
      "#482952",
      "#1f0029",
      "#000000",
    ]);

  const handleMouseEnter = (name: string, count: number) => {
    setTooltipContent({ name, count });
  };

  const handleMouseLeave = () => {
    setTooltipContent({ name: "", count: "" });
  };

  return (
    <div style={{ position: "relative" }}>
      <ComposableMap projection="geoAlbersUsa">
        <Geographies geography="https://unpkg.com/us-atlas/states-10m.json">
          {({ geographies }) =>
            geographies.map((geo) => {
              const name = geo.properties?.name;
              const location = stateData.find((d: any) => d.name === name);
              const count = location ? location.count : 0;
              const uniqueCount = location
                ? count + getUniqueVariation(name)
                : 0;
              const fillColor = location ? colorScale(uniqueCount) : "#CCC";

              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={fillColor}
                  stroke="#FFF"
                  onMouseEnter={() => handleMouseEnter(name || "", count)}
                  onMouseLeave={() => handleMouseLeave()}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>
      {tooltipContent?.count > 0 && (
        <span
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            background: "white",
            padding: "10px",
            border: "1px solid #ccc",
            pointerEvents: "none",
          }}
        >
          {tooltipContent?.name} - {tooltipContent?.count}
        </span>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        {stateData.map(({ name, count }: any) => (
          <div key={name} style={{ marginRight: "10px" }}>
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: colorScale(count),
              }}
            ></div>
            <div style={{ fontSize: "12px" }}>{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Maps;
